import { NgModule } from '@angular/core';

@NgModule({
    declarations: [],
    providers: [],
})
export class InplayApiModule {}
